"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAppInstallUrl = exports.deleteNotificationMedium = exports.editNotificationMedium = exports.addNotificationMedium = exports.fetchNotificationMediumFilterList = exports.fetchNotificationMediumById = exports.fetchNotificationMediumList = exports.fetchChannelList = void 0;

var _lodash = require("lodash");

var _apiService = _interopRequireDefault(require("../utils/api-service"));

var _commonConstants = require("../utils/common-constants");

var _commonUtils = require("../utils/common-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var headers = {
  'content-type': 'application/json'
};

var fetchChannelList = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var notificationMediumId, next, params, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            notificationMediumId = _ref.notificationMediumId, next = _ref.next;
            params = {};

            if (!(0, _lodash.isEmpty)(next)) {
              params.pageToken = next;
            }

            _context.next = 5;
            return _apiService.default.get("api/v1/notification-service/notificationmediums/".concat(notificationMediumId, "/channels"), {
              headers: headers,
              params: params
            });

          case 5:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchChannelList(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.fetchChannelList = fetchChannelList;

var fetchNotificationMediumList = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _apiService.default.get('/api/v1/notification-service/notificationmediums');

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchNotificationMediumList() {
    return _ref3.apply(this, arguments);
  };
}();

exports.fetchNotificationMediumList = fetchNotificationMediumList;

var fetchNotificationMediumById = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
    var response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _apiService.default.get("/api/v1/notification-service/notificationmediums/".concat(id));

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchNotificationMediumById(_x2) {
    return _ref4.apply(this, arguments);
  };
}(); // Notification Mediums CRUD


exports.fetchNotificationMediumById = fetchNotificationMediumById;

var fetchNotificationMediumFilterList = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref5) {
    var search, _ref5$filter, filter, _ref5$next, next, params, response;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            search = _ref5.search, _ref5$filter = _ref5.filter, filter = _ref5$filter === void 0 ? 'co' : _ref5$filter, _ref5$next = _ref5.next, next = _ref5$next === void 0 ? '' : _ref5$next;
            params = {};

            if (search) {
              params.filter = "name%20".concat(filter, "%20'").concat(search, "'");
            }

            if (next) {
              params.pageToken = (0, _commonUtils.getQueryParamsFromUrl)(next, _commonConstants.PAGE_TOKEN);
            }

            _context4.next = 6;
            return _apiService.default.get('/api/v1/notification-service/notificationmediums', {
              params: params
            });

          case 6:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchNotificationMediumFilterList(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

exports.fetchNotificationMediumFilterList = fetchNotificationMediumFilterList;

var addNotificationMedium = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(notificationMediumData) {
    var response;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _apiService.default.post('/api/v1/notification-service/notificationmediums', notificationMediumData);

          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function addNotificationMedium(_x4) {
    return _ref7.apply(this, arguments);
  };
}();

exports.addNotificationMedium = addNotificationMedium;

var editNotificationMedium = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id, notificationMediumData) {
    var response;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _apiService.default.patch("/api/v1/notification-service/notificationmediums/".concat(id), notificationMediumData);

          case 2:
            response = _context6.sent;
            return _context6.abrupt("return", response.data);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function editNotificationMedium(_x5, _x6) {
    return _ref8.apply(this, arguments);
  };
}();

exports.editNotificationMedium = editNotificationMedium;

var deleteNotificationMedium = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
    var payload,
        id,
        response,
        _args7 = arguments;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
            id = payload.id;
            _context7.next = 4;
            return _apiService.default.delete("/api/v1/notification-service/notificationmediums/".concat(id));

          case 4:
            response = _context7.sent;
            return _context7.abrupt("return", response.data);

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function deleteNotificationMedium() {
    return _ref9.apply(this, arguments);
  };
}();

exports.deleteNotificationMedium = deleteNotificationMedium;

var fetchAppInstallUrl = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(appType) {
    var response;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _apiService.default.get("/api/v1/notification-service/notificationmedium/metadata/install/".concat(appType));

          case 2:
            response = _context8.sent;
            return _context8.abrupt("return", response.data);

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function fetchAppInstallUrl(_x7) {
    return _ref10.apply(this, arguments);
  };
}();

exports.fetchAppInstallUrl = fetchAppInstallUrl;